import './theme.css';

// Turbo SPA
import * as Turbo from "@hotwired/turbo";
Turbo.setProgressBarDelay(500);

// Alpine JS + Plugins
import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'
import collapse from '@alpinejs/collapse'

Alpine.plugin(intersect)
Alpine.plugin(collapse)

// Custom Alpine modules
import registerScrollIndicator from './js/scroll-indicator.js'
import registerCounter from './js/counter.js'
import registerCoverageMap from './js/coverage-map.js'
import registerMegaMenu from './js/mega-menu.js'
import registerMobileMenu from './js/mobile-menu.js'
import initLucideIcons from './js/lucide-icons.js'

registerScrollIndicator(Alpine)
registerCounter(Alpine)
registerCoverageMap(Alpine)
registerMegaMenu(Alpine)
registerMobileMenu(Alpine)

initLucideIcons()

window.Alpine = Alpine
Alpine.start()

import './js/header-industrial.js';
import './js/about-timeline.js';
import './js/blog-filters.js';
import './js/contextual-quote-form.js';
import './js/home-stats-rail.js';

// Re-init on Turbo navigation
document.addEventListener("turbo:load", function () {
    // Re-render lucide placeholders before Alpine scans directives.
    initLucideIcons();

    // Turbo swaps <body>; re-init Alpine directives/components on the new DOM.
    Alpine.initTree(document.body);

    // Re-scan sections for scroll indicator after page change
    if (Alpine.store('scrollIndicator')) {
        Alpine.store('scrollIndicator').scan();
        Alpine.store('scrollIndicator').update();
    }
});
